import CustomImageLoader from "@/components/Loader/CustomImageLoader";
import { Box } from "@mui/material";

export default function ImageAsset({
  asset,
  isLoadingAssetDetails,
}: {
  asset: {
    image: string;
    name: string;
    width: number | undefined;
    height: number | undefined;
  };
  isLoadingAssetDetails: boolean;
}) {
  const assetWidth = asset.width ?? 500;
  const assetHeight = asset.height ?? 500;

  return (
    <CustomImageLoader
      width={assetWidth}
      height={assetHeight}
      isLoading={isLoadingAssetDetails}
    >
      <Box
        sx={{
          maxWidth: "100%",
          maxHeight: "calc(100vh - 250px)",
          width: assetWidth,
          height: assetHeight,
          aspectRatio: `${assetWidth} / ${assetHeight}`,
          "& iframe": {
            width: "100%",
            height: "100%",
            border: "none",
          },
        }}
      >
        <iframe src={asset.image} title={asset.name} />
      </Box>
    </CustomImageLoader>
  );
}
